import { createFileRoute } from "@tanstack/react-router";

import CreateGameSessionPage from "~/pages/gameSession/CreateGameSessionPage.tsx";

type CreateGameSessionSearchParams = {
    teamId?: string;
};

export const Route = createFileRoute("/_auth/game-session/create")({
    // The router parses the search string as JSON, so `?teamId=5` arrives as a number.
    validateSearch: (search: Record<string, unknown>): CreateGameSessionSearchParams => ({
        teamId:
            typeof search.teamId === "string" || typeof search.teamId === "number" ? String(search.teamId) : undefined,
    }),
    component: CreateGameSessionPage,
});
